import AdvancedController from "./advanced-controller";
import { gsap } from "gsap";
import Hunt from 'huntjs';

export default class KeyvisualController extends AdvancedController {
  static targets = [
    // 'content'
    "fullscreenVideo",
    "backgroundVideo",
  ];

  static values = {
    // isOpen: Boolean
    fullscreenVideo: String,
  };

  connect() {
    super.connect();

    new Hunt(this.element, {
      persist: true,
      enter: () => this.playBackgroundVideo(),
      leave: () => this.pauseBackgroundVideo(),
    });
  }

  playBackgroundVideo() {
    if (this.hasBackgroundVideoTarget) {
      this.backgroundVideoTarget.play();
    }
  }

  pauseBackgroundVideo() {
    if (this.hasBackgroundVideoTarget) {
      this.backgroundVideoTarget.pause();
    }
  }

  onFullscreen(e) {
    e.preventDefault();
    // set the video source
    this.fullscreenVideoTarget.setAttribute("src", this.fullscreenVideoValue);
    // request fullscreen
    const elem = this.fullscreenVideoTarget;
    var fullscreen =
      elem.webkitRequestFullscreen ||
      elem.mozRequestFullScreen ||
      elem.msRequestFullscreen;
    fullscreen.call(this.fullscreenVideoTarget);
    // play the video
    this.fullscreenVideoTarget.play();
  }
}
